import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import "../styles/LandingPage.css";
import "../styles/AboutBhashini.css";
import lp1 from "../images/landingpage1.png";
import lp2 from "../images/Drishtilib-img.png";

export default function LandingPage() {
  return (
    <div className="landing-page" lang="en">
      <Navbar />

       <header className="landing-hero">
        <div className="landing-hero-inner">
          <div className="landing-hero-left">
            <h1 className="landing-hero-title">Turning Every Book into a Voice</h1>
            <p className="landing-hero-subtitle">
              Drishti-Library is a digital platform that makes books in Indian languages accessible to everyone, 
              especially those who are visually challenged or have difficulty reading print.
            </p>

            <div className="landing-hero-ctas">
              <Link to="/signin" className="landing-btn landing-btn-primary">Browse Library</Link>
              <a href="#features" className="landing-btn landing-btn-ghost">Learn More</a>
            </div>

            <ul className="landing-hero-features">
              <li>🎧 12 Indian Languages</li>
              <li>⚡ OCR & TTS Powered</li>
              <li>♿ WCAG 2.2 Level AA</li>
            </ul>
          </div>

         <div className="landing-hero-right">
            <div className="landing-hero-image">
              <img src={lp1} alt="Books transforming into audio waves with headphones" />
            </div>
          </div>
        </div>
      </header>
{/* 
      <section id="about-bhashini" className="about-bhashini-section">
        <div className="landing-container">
          <h2 className="landing-section-title">About BhashiniDrishti</h2>

          <p>
            BhashiniDrishti is a pioneering national platform powered by the Government of India’s visionary Bhashini Mission, created to make information, education, governance, and public knowledge fully accessible to the visually challenged. The initiative harnesses advanced Indian-language AI technologies—including Optical Character Recognition (OCR), Text-to-Speech (TTS), and Automatic Speech Recognition (ASR)—to break long-standing visual and linguistic barriers and enable inclusive digital participation for all.
          </p>

          <h3>National-Scale Indian Language Support</h3>
          <p>
            Built on robust national AI models, BhashiniDrishti supports 12 scheduled Indian languages, ensuring seamless access for visually impaired users across India—whether in major cities, small towns, or rural and tribal regions. The platform empowers citizens to interact with digital content and government services in their own mother tongue, advancing India’s commitment to linguistic equity, digital empowerment, and voices for all.
          </p>
        </div>
      </section>

      <section id="drishti-suite" className="landing-suite-section">
        <div className="landing-container">
          <h2 className="landing-section-title">The Drishti Suite of Assistive Tools</h2>
          <p className="landing-section-subtitle">BhashiniDrishti delivers its mission through a unified suite of three flagship applications. Each tool addresses a critical accessibility need and is purpose-built for the visually challenged community.</p>

          <div className="suite-grid">
            <article className="suite-card" aria-labelledby="lib-title">
              <div className="suite-badge">1</div>
              <h3 id="lib-title">Drishti-Library</h3>
              <p className="landing-muted"><strong>Turning Every Book into a Voice</strong><br />
                Drishti-Library converts scanned pages and printed books into clean Unicode text using Bhashini’s state-of-the-art OCR. It then generates natural, human-like audio in multiple Indian languages using Bhashini’s neural TTS system. Ideal for education, self-learning, and digital libraries.</p>
            </article>

            <article className="suite-card" aria-labelledby="braille-title">
              <div className="suite-badge">2</div>
              <h3 id="braille-title">Drishti-Braille</h3>
              <p className="landing-muted"><strong>From Pixels to Touch</strong><br />
                Drishti-Braille transforms scanned documents and images into Grade-1 Braille for 12 Indian languages using AI-driven OCR. Outputs are compatible with Braille displays and embossers, enabling tactile reading of textbooks, government forms, and literature.</p>
            </article>

            <article className="suite-card" aria-labelledby="sabha-title">
              <div className="suite-badge">3</div>
              <h3 id="sabha-title">Drishti-Sabha</h3>
              <p className="landing-muted"><strong>Voice to Democracy — Powered by Bhashini</strong><br />
                Drishti-Sabha is India’s first voice-enabled, multilingual question-answering system for Punjab Vidhan Sabha debates. Using OCR, ASR, and TTS, the platform digitizes and makes searchable eight decades of legislative proceedings. Visually challenged users can ask questions aloud and listen to synthesized answers, accessing democratic knowledge like never before.</p>
            </article>
          </div>
        </div>
      </section> */}

    {/* How It Works */}
      <section id="features" className="landing-how-it-works">
        <div className="landing-container">
          <h2 className="landing-section-title">How It Works</h2>
          <p className="landing-section-subtitle">
            Powered by Government of India's Bhashini initiative
          </p>

          <div className="landing-steps-grid">
            <div className="landing-step-card">
              <div className="landing-step-number">1</div>
              <h3>Upload & Convert</h3>
              <p className="landing-muted">
                Upload books in PDF or image format. Our OCR technology accurately converts them into digital text.
              </p>
            </div>

            <div className="landing-step-card">
              <div className="landing-step-number">2</div>
              <h3>Natural Narration</h3>
              <p className="landing-muted">
                Bhashini's TTS engine transforms text into natural-sounding audio in 12 Indian languages.
              </p>
            </div>

            <div className="landing-step-card">
              <div className="landing-step-number">3</div>
              <h3>Personalize</h3>
              <p className="landing-muted">
                Customize your experience with adjustable playback speed, bookmarks, and personalized settings.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-languages-section">
        <div className="landing-container">
          <h2 className="landing-section-title">12 Indian Languages Supported</h2>
          <div className="landing-languages-grid">
            {['Assamese', 'Bengali', 'Gujarati', 'Hindi', 'Kannada', 'Malayalam', 'Manipuri', 'Marathi', 'Punjabi', 'Tamil', 'Telugu', 'Odia'].map(lang => (
              <div key={lang} className="landing-language-tag">{lang}</div>
            ))}
          </div>
        </div>
      </section>

      <div className="landing-accessibility-image">
        <img src={lp2} alt="Person using Drishti-Library with accessibility features" />
      </div>

      <section className="landing-accessibility-section">
        <div className="landing-container">
          <h2 className="landing-section-title">Designed for Everyone</h2>
          <p className="landing-section-subtitle">
            Built with universal accessibility in mind - WCAG 2.2 Level AA compliant
          </p>

          <div className="landing-feature-grid">
            <div className="landing-feature-card">
              <div className="landing-feature-icon">⌨️</div>
              <h3>Easy Keyboard Navigation</h3>
              <p className="landing-muted">
                Control the entire website using only your keyboard (Tab, Arrow, and Enter keys). 
                Perfect for users who rely on assistive technologies.
              </p>
            </div>

            <div className="landing-feature-card">
              <div className="landing-feature-icon">🔊</div>
              <h3>Screen Reader Friendly</h3>
              <p className="landing-muted">
                Works seamlessly with NVDA, JAWS, and VoiceOver. Clear spoken feedback and 
                well-organized layout for non-visual users.
              </p>
            </div>

            <div className="landing-feature-card">
              <div className="landing-feature-icon">🎨</div>
              <h3>Customizable Experience</h3>
              <p className="landing-muted">
                Adjust speech speed, select different voices, and contrast. 
                Optimized for partially sighted and low-vision users.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Collection */}
      <section className="landing-collection-section">
        <div className="landing-container">
          <h2 className="landing-section-title">Our Growing Collection</h2>
          <div className="landing-collection-content">
            <div className="landing-collection-text">
              <h3>Starting with Education</h3>
              <p className="landing-muted">
                We are starting by digitizing undergraduate textbooks. This ensures that visually impaired students have equal access to their essential study materials. In the future, we plan to add more resources, including reference books, and general literature in various Indian languages.
              </p>
              <h3 style={{marginTop: '20px'}}>Future Expansion</h3>
              <p className="landing-muted">
                Soon we'll add reference books, academic resources, and general literature in various Indian languages.
              </p>
            </div>
          </div>
        </div>
      </section>

      <section className="landing-cta-section">
        <div className="landing-cta-inner">
          <div className="landing-cta-content">
            <h2>Ready to Start Listening?</h2>
            <p className="landing-muted">
              Join thousands of learners accessing educational content through audio.
            </p>
          </div>
          <div className="landing-cta-actions">
            <Link to="/signup" className="landing-btn landing-btn-primary landing-btn-large">
              Create Free Account
            </Link>
          </div>
        </div>
      </section>

      <footer className="landing-footer">
        <div className="landing-footer-inner">
          <div className="landing-footer-brand">
            <div className="landing-footer-logo">Drishti-Library</div>
            <p className="landing-muted">Turning Every Book into a Voice</p>
          </div>
          <div className="landing-footer-links">
            <Link to="/about">About</Link>
            <a href="mailto:ocr.nltm@research.iiit.ac.in" className="landing-footer-link" aria-label="Email Drishti Library">Contact</a>
          </div>
        </div>
        <div className="landing-footer-bottom">
          <p className="landing-muted">© {new Date().getFullYear()} Drishti-Library. Powered by Bhashini Initiative, IIIT Hyderabad.</p>
        </div>
      </footer>

      <style>{`
        .bhashini-ribbon { background: linear-gradient(90deg,#f7f3ff,#fff); border-bottom:1px solid rgba(0,0,0,0.04); padding:8px 0; }
        .bhashini-ribbon-inner { display:flex; justify-content:space-between; align-items:center; gap:16px; }
        .bhashini-left { font-weight:600; color:var(--landing-text); }
        .why-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:16px; margin:28px 0; }
        .why-card { background:var(--landing-bg-card); padding:20px; border-radius:10px; box-shadow:var(--landing-shadow); border:1px solid var(--landing-border); }
        .suite-grid { display:grid; grid-template-columns:repeat(3,1fr); gap:20px; margin-top:24px; }
        .suite-card { background:linear-gradient(180deg, rgba(255,255,255,0.98), var(--landing-bg-card)); padding:26px; border-radius:12px; box-shadow:var(--landing-shadow-lg); border:1px solid var(--landing-border); }
        .suite-badge { width:44px; height:44px; border-radius:10px; background:var(--landing-primary-light); color:white; display:flex; align-items:center; justify-content:center; font-weight:800; margin-bottom:12px; }
        .suite-list { margin-top:12px; list-style:disc; padding-left:18px; color:var(--landing-text-muted); }
        .suite-cta { margin-top:22px; display:flex; gap:12px; align-items:center; }
        .impact-row { display:flex; gap:18px; justify-content:center; margin-top:22px; }
        .impact-metric { text-align:center; padding:12px 16px; }
        .impact-number { font-size:20px; font-weight:800; color:var(--landing-primary); }
        .impact-label { font-size:13px; color:var(--landing-text-muted); }

        @media (max-width:968px) {
          .why-grid, .suite-grid { grid-template-columns:1fr; }
          .impact-row { flex-direction:column; }
        }
      `}</style>
    </div>
  );
}
